import React, { useEffect, useState } from "react"
import HeaderComponent from "./Header"
import FooterComponent from "./Footer"
import SidebarComponent from "./Sidebar"
import { Container, Row, Col } from "react-bootstrap"

const LayoutComponent = ({ children }) => {
  const [type, setType] = useState(null)
  useEffect(() => {
    const searchParam = new URLSearchParams(window.location.search);
    setType(searchParam.get("type"));
  }, []);
  return (
    <div className="d-flex flex-column min-vh-100">
      <header className="bg-light border-bottom">
        <HeaderComponent />
      </header>
      <main className="flex-grow-1">
        <Container fluid className="px-3">
          <Row>
            <Col md={2} className="d-none d-md-block">
              <SidebarComponent type={type} />
            </Col>
            <Col md={9} className="py-4">
              <Container>
                <Row>
                  <Col className="documentation">
                    {children}
                  </Col>
                </Row>
              </Container>

            </Col>
          </Row>
        </Container>
      </main>
      <FooterComponent />
    </div>
  )
}

export default LayoutComponent
